import { render, staticRenderFns } from "./ProviderSelect.vue?vue&type=template&id=20b9b3d0&scoped=true&"
import script from "./ProviderSelect.vue?vue&type=script&lang=js&"
export * from "./ProviderSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSelect.vue?vue&type=style&index=0&id=20b9b3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9b3d0",
  null
  
)

export default component.exports